"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLanguage = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const CRM_COOKIES_LANGUAGE_KEY = 'cust_lang';
const getLocaleFromPath = () => {
    const url = window.location.href;
    const match = url.match(/\/([a-zA-z]{2}(-[a-zA-z]{2})?)($|\/.*|\?.*)/);
    return match ? match[1] : null;
};
const getLangFromConfig = () => {
    return window.wfLanguageConfig && window.wfLanguageConfig.obLanguage;
};
const getSportsbookLocale = () => {
    return window.WH && window.WH.sportsbook && window.WH.sportsbook.lang;
};
const getLanguage = () => {
    const language = getLangFromConfig() || getSportsbookLocale() || getLocaleFromPath() || js_cookie_1.default.get(CRM_COOKIES_LANGUAGE_KEY);
    return language === 'uk' ? 'en-gb' : language;
};
exports.getLanguage = getLanguage;
